export const parseURLParams = (fullURL: string): ObjectKeyStringKeyValues => {
  const URLObject = new URL(fullURL);
  const urlSearch = URLObject.searchParams;

  const paramsAsObject: ObjectKeyStringKeyValues = {};

  urlSearch.forEach((value, key) => (paramsAsObject[key] = value));

  return paramsAsObject;
};

export const buildFormFetchURL = (params: ObjectKeyStringKeyValues): string => {
  const searchParams = new URLSearchParams();

  Object.keys(params).forEach(key => searchParams.append(key, params[key]));

  //add staging true if development env
  if (process.env.NODE_ENV === 'development') {
    searchParams.append('staging', 'true');
  }

  const fetchURL = new URL(`${process.env.REACT_APP_BASE_URL}/formsna`);
  fetchURL.search = searchParams.toString();

  return fetchURL.href;
};
